import { permitTypeUnit } from '@contracts/permitType/PermitType';
import {
  BooleanField,
  OptionalStringField,
  StringField,
} from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class NameField extends StringField {
  public static fieldName: string = 'name';
}

export class JurisdictionUrlField extends OptionalStringField {
  public static fieldName: string = 'jurisdictionUrl';
  public static validator = yup
    .string()
    .url()
    .trim()
    .nullable()
    .transform((value) => value || null);
}

export class JurisdictionField extends StringField {
  public static fieldName: string = 'jurisdiction';
}

export class TypeField extends StringField {
  public static fieldName: string = 'type';
}

export class CurrencyField extends StringField {
  public static fieldName: string = 'currency';
}

export class HighPriorityField extends BooleanField {
  public static fieldName: string = 'highPriority';
}

export class ShowToClientField extends BooleanField {
  public static fieldName: string = 'showToClient';
}

export class ValidateExpirationDateField extends BooleanField {
  public static fieldName: string = 'validateExpirationDate';
}

export class ValidateExpirationTimeField extends BooleanField {
  public static fieldName: string = 'validateExpirationTime';
}

export class UnitSystemFields {
  public static fieldName: string = 'unit' as const;
  public static validator = yup
    .string()
    .oneOf([permitTypeUnit.IMPERIAL, permitTypeUnit.METRIC])
    .required();
}
